/**
 * @generated SignedSource<<c9ba694d82b3414b1ea481ef4bf98a18>>
 * @relayHash cb5951640e4b2c5a08df07375e608126
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/useFavoritesItemQuery

import { ConcreteRequest } from 'relay-runtime';
export type useFavoritesItemQuery$variables = {
  userId: string;
};
export type useFavoritesItemQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly canShowFolder: boolean | null;
    } | null;
  };
};
export type useFavoritesItemQuery = {
  response: useFavoritesItemQuery$data;
  variables: useFavoritesItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canShowFolder",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFavoritesItemQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useFavoritesItemQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/useFavoritesItemQuery",
    "metadata": {},
    "name": "useFavoritesItemQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "961d59c6a42f2febe60cc3fef5089b2f";

export default node;
